import { render } from "./RegisterWelcome.vue?vue&type=template&id=85817f0e&scoped=true"
import script from "./RegisterWelcome.vue?vue&type=script&lang=js"
export * from "./RegisterWelcome.vue?vue&type=script&lang=js"

import "./RegisterWelcome.vue?vue&type=style&index=0&id=85817f0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85817f0e"]])

export default __exports__